import { render, staticRenderFns } from "./dmoDashboard.vue?vue&type=template&id=22111344&scoped=true"
import script from "./dmoDashboard.vue?vue&type=script&lang=js"
export * from "./dmoDashboard.vue?vue&type=script&lang=js"
import style0 from "./dmoDashboard.vue?vue&type=style&index=0&id=22111344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22111344",
  null
  
)

export default component.exports